import { format } from "date-fns";

export default function formatDate(date) {

    return format(date || new Date(), 'dd/MM/yyyy kk:mm');
}

export function formatDateToYear(date) {
    return format(date || new Date(), 'yyyy')
}